import { TableSchema } from '../metadata-schema';

export const dim_vv_vestiging_vak: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_vv_vestiging_vak",
	"description": "Definitie voor dimension tabel dim_vv_vestiging_vak uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek",
		"nl.topicus.cumlaude.metadata.table.BeheerderVestigingOverride",
		"nl.topicus.cumlaude.metadata.table.Vakspecifiek"
	],
	"properties": {
		"vv_abb_vak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vv_d_geldig_va": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vv_d_geldig_tot": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vv_id_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vv_nm_vak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vv_nm_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
